export default "__VITE_ASSET__BnKZq0Q6__"